module.exports = __webpack_public_path__ + "img/cadeiras.6546af30.jpg";